import { useEffect, useRef } from "react";

// Auto-apply helper: fires `applyFn` `delay`ms after `signature` settles, and
// skips the first render so a panel opening with existing filters doesn't
// re-query. `signature` must be a primitive (JSON.stringify of only the
// committed/valid conditions) so partial edits don't trigger a fire.
export default function useDebouncedApply(signature, applyFn, delay = 600) {
  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    const timer = setTimeout(applyFn, delay);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature]);
}
